<div
  class="custom-quick-cart-link"
  [ngClass]="{ 'd-none': view() !== 'full', 'd-md-block': view() !== 'small', 'custom-mini-cart-active': !isCollapsed }"
  ishClickOutside
  (isClickedOutside)="collapse()"
>
  <a (click)="toggleCollapse()">
    <i class="icon-shopping-bag"></i>
    <span class="custom-mini-cart-link-item-count">{{ itemCount$ | async }}</span>
    @if (itemTotal$ | async; as itemTotal) {
    <span class="mini-cart-price d-none">{{ itemTotal | ishPrice }}</span>
    }
  </a>

  <div class="custom-mini-cart">
    <button
      (click)="allowScroll()"
      type="button"
      class="close custom-mini-cart-close"
      [title]="'dialog.close.text' | translate"
      [attr.aria-label]="'dialog.close.text' | translate"
      (click)="collapse()"
    >
      <span aria-hidden="true"><i class="icon-x"></i> Close</span>
    </button>
    <custom-lazy-mini-basket-content />
  </div>
</div>
@if (!isCollapsed) {
<div (click)="allowScroll()" class="custom-mini-cart-white-drop"></div>
} @if (view() === 'small') {
<a routerLink="/basket" class="item-count-container position-relative">
  <fa-icon [icon]="['fas', 'shopping-cart']" class="header-icon" />
  <span class="badge badge-pill" [ngClass]="basketAnimation$ | async">{{ itemCount$ | async }}</span>
</a>
}

<!-- dummy element tracking basket loading for cypress tests -->
@if (basketLoading$ | async) {
<span class="loading" style="display: none"></span>
}
